import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface RiesgoVial {
  id?: number;
  consecutivo?: string;
  actor_vial: number | string;
  categoria_vial?: number | null;
  tipo_riesgo: number | string;
  descripcion: string;
  actividad: 'RUTINARIA' | 'NO_RUTINARIA';
  ubicacion?: string;
  fecha: string;
  nivel_exposicion: number;
  nivel_probabilidad: number;
 // descripcion_exposicion?: string;
 // descripcion_probabilidad?: string;
  nivel_riesgo?: number;
  clasificacion?: string;
  estado?: number;
  fecha_creacion?: string;
  fechamodificacion?: string;
  color?: string;
  municipioOrigen?: { IDMUN?: number; MUNICIPIO?: string };
  municipioDestino?: { IDMUN?: number; MUNICIPIO?: string };
}

@Injectable({ providedIn: 'root' })
export class RiesgosVialesService {
  private apiUrl = `${environment.apiUrl}/api/riesgos_viales`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<RiesgoVial[]> {
    return this.http.get<RiesgoVial[]>(this.apiUrl, { withCredentials: true });
  }

  getNextRiesgoId(): Observable<any> {
    return this.http.get(`${this.apiUrl}/consecutivo`, { withCredentials: true });
  }

  getByIdPlanAccion(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/plan-accion/${id}`, { withCredentials: true });
  }

  getById(id: number): Observable<RiesgoVial> {
    return this.http.get<RiesgoVial>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  create(data: RiesgoVial): Observable<RiesgoVial> {
    return this.http.post<RiesgoVial>(this.apiUrl, data, { withCredentials: true });
  }

  update(id: number, data: Partial<RiesgoVial>): Observable<RiesgoVial> {
    return this.http.put<RiesgoVial>(`${this.apiUrl}/${id}`, data, { withCredentials: true });
  }

  inactivar(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/inactivar`, { withCredentials: true });
  }

  activar(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/activar`, { withCredentials: true });
  }

  remove(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, { withCredentials: true });
  }
}